var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-full d-flex flex-column justify-content-between" },
    [
      _c(
        "div",
        { staticClass: "col-md-12 comments-section pt-4" },
        [
          _c("nav", { staticClass: "comments-nav flex mb-1" }, [
            _c(
              "div",
              {
                staticClass: "nav-item nav-link comments-nav-link pointer",
                class: [_vm.commentsSectionStep === 1 ? "active" : ""],
                on: {
                  click: function($event) {
                    _vm.setCommentsStep(1)
                  }
                }
              },
              [_vm._v("\n        Comments\n      ")]
            ),
            _vm._v(" "),
            _vm.$_can("claims.logs.index")
              ? _c(
                  "div",
                  {
                    staticClass: "nav-item nav-link comments-nav-link pointer",
                    class: [_vm.commentsSectionStep === 2 ? "active" : ""],
                    on: {
                      click: function($event) {
                        _vm.setCommentsStep(2)
                      }
                    }
                  },
                  [_vm._v("\n        Logs\n      ")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.commentsSectionStep === 1
            ? _c(
                "div",
                { staticClass: "comments-list" },
                _vm._l(_vm.claim.notes, function(note) {
                  return _c(
                    "div",
                    {
                      key: note.id,
                      staticClass: "single-comment flex flex-column mb-4"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 comment-name" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(note.user.first_name) +
                              " " +
                              _vm._s(note.user.last_name) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 flex flex-justify-end comment-date"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(note.date) +
                                "\n          "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12 comment-note" }, [
                        _c(
                          "div",
                          { staticClass: "comment-format" },
                          [
                            _c("read-more", {
                              staticClass: "show-more",
                              attrs: {
                                "more-str": "Show more",
                                text: note.note,
                                "less-str": "Show less",
                                "max-chars": 300
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.commentsSectionStep === 2
            ? _c("logs", {
                attrs: { claim: _vm.claim },
                on: {
                  refresh: function($event) {
                    _vm.$emit("update")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.commentsSectionStep !== 2
        ? _c(
            "div",
            { staticClass: "comment-create flex justify-content-center" },
            [
              _c(
                "span",
                { staticClass: "comment-area flex" },
                [
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "note" }
                  }),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.comment,
                        expression: "comment"
                      },
                      { name: "auto-resize", rawName: "v-auto-resize" }
                    ],
                    domProps: { value: _vm.comment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.comment = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: _vm.buttonDisabled },
                      on: { click: _vm.saveNote }
                    },
                    [_c("i", { staticClass: "fa fa-paper-plane" })]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15f224e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f224e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/Comments.vue
// module id = null
// module chunks = 